exports.titles = {
    text: Lang.langGet('Text'),
    rssfeed: Lang.langGet('RSS Feed'),
    streaming: Lang.langGet('Streaming'),
    iframe: Lang.langGet('Web'),
    youtube: Lang.langGet('YouTube'),
    countdown: Lang.langGet('Countdown'),
    qrcode: Lang.langGet('QR Code'),
    picture: Lang.langGet('Picture'),
    video: Lang.langGet('Video'),
    pdf: Lang.langGet('PDF'),
    ppt: Lang.langGet('Powerpoint'),
    emptyrectangle: Lang.langGet('Empty Rectangle'),
    template: Lang.langGet('Template'),
    campaign: Lang.langGet('Campaign'),
    clock: Lang.langGet('Clock'),
    day: Lang.langGet('Day'),
    weather: Lang.langGet('Weather'),
    layer: Lang.langGet('Layer'),
    esign: Lang.langGet('eSign'),
    widget: Lang.langGet('Widget'),
}
